import { AccountProps } from "../typings";

export const ACCOUNT_INITIAL_VALUES: AccountProps = {
    id: 0,
    account_title: "",
    is_system_generated: false,
  };